import React, { useState, useEffect } from "react";
import { useTranslation } from "../contexts/TranslationContext";

export default function ResumePreview({ resumeAntigo, descricoesGeradas }) {
  const { t } = useTranslation();

  const [empresas, setEmpresas] = useState([]);
  const [cargos, setCargos] = useState([]);
  const [descricoes, setDescricoes] = useState([]);
  const [skills, setSkills] = useState([]);
  const [summary, setSummary] = useState("");
  const [desiredRole, setDesiredRole] = useState("");

  useEffect(() => {
    const experiences = descricoesGeradas?.experiences || descricoesGeradas;
    if (!Array.isArray(experiences)) return;

    setEmpresas(experiences.map(d => d.empresa));
    setCargos(experiences.map(d => d.cargo));
    setDescricoes(experiences.map(d => d.descricao));
    setSkills(descricoesGeradas?.skills || []);
    setSummary(descricoesGeradas?.summary || "");
    setDesiredRole(descricoesGeradas?.desiredRole || "");
  }, [descricoesGeradas]);

  if (!empresas.length || !cargos.length || !descricoes.length) {
    return <p className="text-gray-400">{t('resumePreview.loading')}</p>;
  }

  const formatDescricao = (descricao) => {
    if (!descricao) return null;
    return descricao
      .split(/\n|(?<=\.\s)/)
      .filter(Boolean)
      .map((line, idx) => (
        <p key={idx} className="text-sm text-gray-400 ml-4 mb-1">{line.trim()}</p>
      ));
  };

  return (
    <div className="bg-white/10 p-6 rounded-lg shadow-lg h-full flex flex-col flex-1">
      <h2 className="text-xl font-bold text-brand-400 mb-4">{t('resumePreview.tunedResume')}</h2>

      {desiredRole && (
        <div className="mb-4">
          <h3 className="text-xs font-bold uppercase tracking-wider text-gray-500 mb-1">{t('configureResume.desiredRole')}</h3>
          <p className="text-white font-semibold">{desiredRole}</p>
        </div>
      )}

      {summary && (
        <div className="mb-4">
          <h3 className="text-xs font-bold uppercase tracking-wider text-gray-500 mb-1">{t('configureResume.summary')}</h3>
          <p className="text-sm text-gray-300 leading-relaxed">{summary}</p>
        </div>
      )}

      {skills.length > 0 && (
        <div className="mb-6">
          <h3 className="text-lg font-semibold text-green-400 mb-2">{t('resumePreview.suggestedSkills')}</h3>
          <div className="flex flex-wrap gap-2">
            {skills.map((skill, idx) => (
              <span key={idx} className="px-3 py-1 bg-green-600/30 text-green-300 rounded-full text-sm">
                {skill}
              </span>
            ))}
          </div>
        </div>
      )}

      <div className="space-y-4">
        {empresas.map((empresa, idx) => (
          <div key={idx} className="space-y-1">
            <p className="font-semibold">{cargos[idx]} @ {empresa}</p>
            {formatDescricao(descricoes[idx])}
          </div>
        ))}
      </div>
    </div>
  );
}
